import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type SaveBookmarkResponce } from '../services/saveBookmarkService'

export interface SaveBookmarkDataState {
  isLoading: boolean
  loadingError: string | undefined
  saveBookmarkData: SaveBookmarkResponce | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
export const initialState: SaveBookmarkDataState = {
  isLoading: false,
  loadingError: undefined,
  saveBookmarkData: { message: 'Bookmark added successfully' },
  httpStatus: 201
}

// Slice to return from action
export const SaveBookmarkDataListState = createSlice({
  name: 'SaveBookmarkData',
  initialState,
  reducers: {
    SaveBookmarkDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        saveBookmarkData: undefined,
        httpStatus: 0
      }
    },
    SaveBookmarkDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        saveBookmarkData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    SaveBookmarkDataErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        saveBookmarkData: { dashboardId: '', message: action.payload.errorMessage }
      }
    },
    SaveBookmarkDataReset: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: false,
        loadingError: undefined,
        saveBookmarkData: undefined,
        httpStatus: 0
      }
    }
  }
})

// Actions to export
export const {
  SaveBookmarkDataLoadingAction,
  SaveBookmarkDataUpdateAction,
  SaveBookmarkDataErrorAction,
  SaveBookmarkDataReset
} = SaveBookmarkDataListState.actions

export default SaveBookmarkDataListState.reducer
